import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import { Route, Switch, withRouter } from 'react-router-dom'
import config from '@adc/configment'
import { MorpheusApplicationShell, favicon, utils } from '@adc/ui-morpheus'
import { CommandPalette } from '../components/commandPalette'
import { InternalToolbarLoader } from '../components/internalToolbar/InternalToolbarLoader'
import { PermissionsProvider } from '../authorization/PermissionsProvider'
import MasterContainer from './master'
import Login from './login'
import EmbedContainer from './embed'

import '@adc/datatable/lib/styles.css'
import '@adc/ui-morpheus/lib/styles.css'
import '../scss/base.scss'

const { UserPermissions } = utils

const App = ({ user }) => {
  const renderEmbedContainer = props => {
    if (
      user &&
      user.logged_in &&
      user.authorities &&
      (user.authorities.includes('MRP_LOGIN') ||
        user.authorities.includes('ML'))
    ) {
      return <EmbedContainer {...props} />
    } else {
      return <Login />
    }
  }

  const renderMasterContainer = () => {
    /**
     * This check is in case user was logged in previously but is no longer or
     * the user gets a new token that no longer has the proper authority,
     * in which case we kick them out to login.
     */
    if (
      user &&
      user.logged_in &&
      user.authorities &&
      (user.authorities.includes('MRP_LOGIN') ||
        user.authorities.includes('ML'))
    ) {
      const resourceAuthorityMap = config.get('RESOURCE_AUTHORITY_MAP')
      const permissions = new UserPermissions(
        user.authorities,
        resourceAuthorityMap
      )
      return <MasterContainer permissions={permissions} />
    } else {
      return <Login />
    }
  }

  return (
    <PermissionsProvider authorities={user && user.authorities}>
      <MorpheusApplicationShell user={user}>
        <div className='full-container'>
          <Helmet
            title='Morpheus'
            link={[
              { rel: 'canonical', href: 'https://auction.com' },
              { rel: 'icon', href: favicon },
            ]}
          />
          <CommandPalette />
          <InternalToolbarLoader />
          <main>
            <Switch>
              <Route path='/embed' render={renderEmbedContainer} />
              <Route path='/' render={renderMasterContainer} />
            </Switch>
          </main>
        </div>
      </MorpheusApplicationShell>
    </PermissionsProvider>
  )
}

App.propTypes = {
  user: PropTypes.object.isRequired,
}

const mapStateToProps = store => ({
  user: store.user,
  featureFlags: store.featureFlags,
})
/**
 * NOTE: it's important to use withRouter here (and on any routing components wrapped with HOC) so
 * that the updates aren't blocked.  See the following for a detailed explanation:
 * https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/guides/blocked-updates.md
 */
export default withRouter(connect(mapStateToProps)(App))
